/**
 * @goanna-im/shared — the single source of truth for the data model, the
 * real-time protocol, and the pure domain logic shared by the presenter, the
 * producer console and the server.
 *
 * Goanna IM Presenter — A presenter and production Internet Machine.
 * IM = Internet Machine.
 */
export * from './model.js';
export * from './protocol.js';
export * from './scroll.js';
export * from './layout.js';
export * from './parser.js';
export * from './cues.js';
export * from './timers.js';
export * from './defaults.js';
export * from './entitlements.js';
export * from './ai.js';
export * from './voice.js';
export * from './voicematch.js';
export * from './ids.js';
export const PRODUCT_NAME = 'Goanna IM Presenter';
export const PRODUCT_SUBTITLE = 'A presenter and production Internet Machine';
//# sourceMappingURL=index.js.map